import React, {SyntheticEvent} from 'react'

import editDependencyLag from "../../../gd-modules/gantt-chart/actions/edit-dependency-lag"
import ModelEntity from "../../../model2/model-entity"
import Task from "../../../model2/task/task"
import FieldProto from "../../../fields3/proto/field-proto"
import {DependencyType} from "../../../model2/dependency/const"
import DependenciesManager from "../../../gd/manager/dependencies-manager"
import getDependencyInfo from "./get-dependency-info"
import {FieldType} from "../../../fields3/field-type"
import type TasksViewManager from "../../../gd-modules/tasks-view/core/manager"

type Props = {
    task?       : ModelEntity
    entity      : ModelEntity
    field       : FieldProto
    manager?    : TasksViewManager
    onClick?    : callback
}

// const debug = "DependencyView"
const debug = false

export default function DependencyView(props: Props) {

    const task = props.task as Task
    const dependency = props.entity as Task

    const onClickView = (e: SyntheticEvent) => {

        e.stopPropagation()

        props.onClick?.(e, dependency)
    }

    const onEditLag = (dependency: any, newLagValue: number) => {
        editDependencyLag({
            setStartEnd: (successorListItemId: ID, newStartDate: Moment, newEndDate: Moment) => {
                debug && console.log(debug, 'editDependencyLag setStartEnd', successorListItemId, newStartDate, newEndDate)

                const task = dependency.successor.item // always successor is moved
                gd.api.Task.startEnd(task.id, newStartDate, newEndDate, task.scheduleDate, !!task.scheduleDate, gd.companyId)
            }
        }, dependency, newLagValue)
    }

    // firstRID/secondRID are RIDs ("t-xxx"), the form every onRemove consumer is handed - the
    // collections are keyed by RID, and the delete API wants the pair split back into typed ids
    const onDeletePredecessorDependency = (firstRID: RID, secondRID: RID, type: DependencyType) => {

        gd.modals.confirm.deleteTextMessage('Dependency','Are you sure that you want to delete this dependency?',async ()=>{
            task.predecessors.remove(dependency.rid)
            task.successors.remove(dependency.rid)
            gd.api.Dependency.delete(DependenciesManager.convertFirstSecondToDependency(type, firstRID, secondRID))
            gd.modal.hide()
        })
    }

    const onClickInfo = (e: SyntheticEvent) => {
        e.stopPropagation()

        // In gantt views the collection entries are the plain entity models taken from resources -
        // they have no dependencyId, so build the info from the dependency record instead,
        // otherwise the modal has nothing to show and closes itself right away.
        const isPredecessor     = props.field.type === FieldType.PREDECESSORS
        const dependencyInfo    = getDependencyInfo(props.manager?.data?.resources,
                                                    isPredecessor ? dependency : task,
                                                    isPredecessor ? task : dependency)

        debug && console.log(debug, 'onClickInfo', dependencyInfo, dependency?.dependencyId)

        gd.modals.dependency.dependencyInfo(dependencyInfo, dependency?.dependencyId, onEditLag, onDeletePredecessorDependency, dependency.acl.canReadOnly)
    }


    return (
        <div className  = "gd-dependency-view ui5-property m-r-5 min-w-75 h-26 border-box"
             onClick    = {onClickView}
        >

            <div className="flex-row-between-center position-relative h-100p">
                <div className="short-id-label txt-truncate">
                    #{dependency.shortId || dependency.rid}
                </div>
                <div className  = "buttons flex-row-center-right ui5-bg-gray h-100p p-l-10">

                    <div className  = "ui5-control-button s-20 m-r-5"
                         onClick    = {onClickView}
                    >
                        <div className="i5-eye ui5-ico-13"/>
                    </div>

                    <div className  = "ui5-control-button s-20"
                         onClick    = {onClickInfo}
                    >
                        <div className="i5-info-2 ui5-ico-13"/>
                    </div>

                </div>
            </div>

        </div>
    );
}
